(() => {
  const root = document.documentElement;
  let dot = null;
  let ring = null;
  let activated = false;
  let mouseX = -100;
  let mouseY = -100;
  let ringX = -100;
  let ringY = -100;
  let rafId = 0;

  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;

  const closestInteractive = (target) => {
    if (!(target instanceof Element)) return false;
    return !!target.closest('a, button, summary, select, label[for], [role="button"], [role="link"], input[type="submit"], input[type="button"], input[type="checkbox"], input[type="radio"], .button, .shopify-payment-button, [data-zenith-cursor="interactive"]');
  };

  const ensureCursor = () => {
    if (activated) return;
    activated = true;
    dot = document.createElement('div');
    ring = document.createElement('div');
    dot.className = 'zenith-cursor-dot';
    ring.className = 'zenith-cursor-ring';
    dot.setAttribute('aria-hidden', 'true');
    ring.setAttribute('aria-hidden', 'true');
    document.body.append(dot, ring);
    root.classList.add('zenith-custom-cursor-enabled');

    const render = () => {
      if (!activated || !dot || !ring) return;
      if (reducedMotion) {
        ringX = mouseX;
        ringY = mouseY;
      } else {
        ringX += (mouseX - ringX) * 0.20;
        ringY += (mouseY - ringY) * 0.20;
      }
      dot.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`;
      ring.style.transform = `translate3d(${ringX}px, ${ringY}px, 0)`;
      rafId = requestAnimationFrame(render);
    };
    rafId = requestAnimationFrame(render);
  };

  const onMouseMove = (event) => {
    ensureCursor();
    mouseX = event.clientX;
    mouseY = event.clientY;
    if (ringX < -50) { ringX = mouseX; ringY = mouseY; }
    root.classList.add('zenith-cursor-visible');
    root.classList.toggle('zenith-cursor-interactive', closestInteractive(event.target));
  };

  /* Mouse movement itself is the capability test. This works reliably in Shopify Preview/iframes. */
  window.addEventListener('mousemove', onMouseMove, { passive: true });

  document.addEventListener('mouseover', (event) => {
    if (!activated) return;
    root.classList.toggle('zenith-cursor-interactive', closestInteractive(event.target));
  }, { passive: true });

  document.addEventListener('mousedown', () => {
    if (activated) root.classList.add('zenith-cursor-pressed');
  });
  document.addEventListener('mouseup', () => root.classList.remove('zenith-cursor-pressed'));
  document.addEventListener('mouseleave', () => root.classList.remove('zenith-cursor-visible','zenith-cursor-interactive','zenith-cursor-pressed'));
  window.addEventListener('blur', () => root.classList.remove('zenith-cursor-visible','zenith-cursor-interactive','zenith-cursor-pressed'));

  /* If the browser switches to touch input, stop hiding the native pointer. */
  window.addEventListener('touchstart', () => {
    if (!activated) return;
    activated = false;
    if (rafId) cancelAnimationFrame(rafId);
    root.classList.remove('zenith-custom-cursor-enabled','zenith-cursor-visible','zenith-cursor-interactive','zenith-cursor-pressed');
    dot?.remove();
    ring?.remove();
    dot = ring = null;
  }, { passive: true, once: true });
})();
